import Controller from "@ember/controller"
import { inject as service } from "@ember/service"

export default class AccountController extends Controller {
  @service modalManager

  showModal = (userId) => {
    this.modalManager.openModal("user/account", {
      userId: userId,
    })
  }
}
